var _ellipse, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0716,
    cy: 13.5414,
    rx: 13.0716,
    ry: 13.5414,
    fill: "#F4F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8876 15.0355L13 21L18.1124 15.0355C18.6807 14.3725 19 13.4732 19 12.5355C19 10.5829 17.6432 9 15.9695 9C15.1658 9 14.395 9.37249 13.8267 10.0355L13 11L12.1733 10.0355C11.605 9.37249 10.8342 9 10.0305 9C8.35678 9 7 10.5829 7 12.5355C7 13.4732 7.31928 14.3725 7.8876 15.0355Z",
    fill: "#2898FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10477 15.001C6.35977 14.2322 5.94141 13.193 5.94141 12.1095C5.94141 11.0201 6.36418 9.97491 7.11725 9.20455C7.87032 8.43419 8.89204 8.00171 9.95706 8.00171C11.0221 8.00171 12.0438 8.43419 12.7969 9.20455L13.0714 9.48537L13.3459 9.20455C14.099 8.43419 15.1199 8.00171 16.185 8.00171C17.2507 8.00171 18.2717 8.43419 19.0248 9.20455C19.7778 9.97491 20.2014 11.0201 20.2014 12.1095C20.2014 13.193 19.783 14.2322 19.0372 15.001L13.5896 20.9018C13.4553 21.0475 13.2673 21.1301 13.0714 21.1301C12.8754 21.1301 12.6875 21.0475 12.5532 20.9018L7.10477 15.001ZM13.0714 19.3386L18.0023 13.9979L18.017 13.9829C18.5022 13.4858 18.7752 12.8123 18.7752 12.1095C18.7752 11.4068 18.5022 10.7333 18.017 10.2362C17.5311 9.73915 16.872 9.45983 16.185 9.45983C15.4987 9.45983 14.8396 9.73915 14.3537 10.2362L13.5756 11.0328C13.2967 11.3174 12.8453 11.3174 12.5671 11.0328L11.7884 10.2362C11.3032 9.73915 10.6441 9.45983 9.95706 9.45983C9.27004 9.45983 8.61166 9.73915 8.12576 10.2362C7.63986 10.7333 7.36754 11.4068 7.36754 12.1095C7.36754 12.8123 7.63986 13.4858 8.12576 13.9829C8.1309 13.9881 8.1353 13.9926 8.1397 13.9979L13.0714 19.3386Z",
    fill: "#2898FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.bda9b8b81efa4b2520916727549b67b9.svg";
export { ForwardRef as ReactComponent };